import * as http from 'utils/http';
import { urlToId } from 'utils/converters';
import config from 'config';

const DEFAULT_COUNTRY = 'ES';

export const createAddress = ({ is_manual, ...address }) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}${is_manual ? 'manual_' : ''}addresses/`, address)
      .catch((err) => {
        throw err;
      })
      .then((address) => {
        return address;
      });
  };
};

// NOTE: This is not really a redux action dispatcher
export const fetchAddresses = (shipper) => {
  return http.get(
    config.API_URL +
      'addresses/?shipper=' +
      (typeof shipper === 'object' ? shipper.id : urlToId(shipper)) +
      '&page_size=0'
  );
};

export const zipToCity = (_zip, _country) => {
  return (dispatch, getState, config) => {
    const country = _country || DEFAULT_COUNTRY;
    const zip = (_zip || '').replace(/ /g, '');
    return http
      .get(`${config.API_URL}city/${zip}/?country=${country}`)
      .catch((err) => {
        throw err;
      })
      .then((address) => {
        return address;
      });
  };
};

// NOTICE: This is a wrapper. Currying the function for (country) => (zip) does not work because of
//         the "trick" that react-redux does with action creators.
export const zipToCityWithCountry = (country, zip) => {
  return (dispatch, getState, config) => {
    return zipToCity(zip, country)(dispatch, getState, config);
  };
};
